import React, {Component} from "react";
import ReactLoading from "react-loading";
import './AppointmentMinute.css';

class AppointmentMinute extends Component {
    constructor(props) {
        super(props);
        this.state = {
          minutes:[],
          selectedIndex:null
        };
        this.handleMinute   = this.handleMinute.bind(this);
        this.getMinuteClass = this.getMinuteClass.bind(this);
        this.isLoading      = this.isLoading.bind(this);
    }

    componentDidMount () {
        let {appointmentMinutes}=this.props;
        let minutes=[];
        for (let minute in appointmentMinutes) {
            minutes.push(minute);
        }
        minutes.sort((minute1, minute2) => minute1 - minute2);
        this.setState({minutes});
    }

    handleMinute(minute,selectedKey){
        let {date,hour} = this.props;
        this.setState({selectedKey},()=>this.props.handleMinute(date,hour,minute));
    }

    getMinuteClass(minute) {
        let {count,targetCount} =  this.props.appointmentMinutes[minute];
        return ((count >= targetCount) ? '' : 'active-minute ') + 'minute-button'
    }

    isDisabled(minute) {
        let {count,targetCount} =  this.props.appointmentMinutes[minute];
        return (count >= targetCount);
    }

    isLoading(minute,selectedKey){
        let self = this;
        let loading = self.props.loading;
        return loading && (this.state.selectedKey===selectedKey);
    }

    render() {
        return (
            <div className='minute-buttons-div' style={{
                width: 'fit-content',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                alignItems: 'center'
            }}>
                {this.state.minutes.map((minute, index) =>
                        <button key={this.props.date +"_"+ this.props.hour + "_" +minute+"_"+ index}
                                disabled={this.isDisabled(minute)}
                                onClick={e => {this.handleMinute(minute,this.props.date +"_"+ this.props.hour + "_" +minute+"_"+ index)}}
                                className={this.getMinuteClass(minute)}>
                            <div className="row" style={{margin: "0", position: "relative"}}>
                                {this.isLoading(minute,this.props.date +"_"+ this.props.hour + "_" +minute+"_"+ index) &&
                                <ReactLoading type="spinningBubbles" style={{
                                    width: "18px",
                                    height: "5px",
                                    margin: "0",
                                    fill: "#fff",
                                    position: "absolute",
                                    left: "30%",

                                }}/>
                                }
                                {this.isLoading(minute,this.props.date +"_"+ this.props.hour + "_" +minute+"_"+ index) ?
                                    <span style={{color: "#78b1d7"}}>{this.props.hour +":"+ minute}</span>
                                    :
                                    <span>{this.props.hour +":"+ minute}</span>
                                }
                            </div>

                        </button>
                    )}
            </div>);
    }
}

export default AppointmentMinute;